import React from 'react';
import './App.css';

export default function AboutService({ onBackClick }) {
  return (
    <main className="page-content about-overview" style={{ padding: '28px 16px', paddingBottom: '180px', maxWidth: 1100, margin: '0 auto', position: 'relative' }}>
      <button
        className="back-button"
        onClick={() => onBackClick && onBackClick('home')}
        style={{
          backgroundColor: '#0b6b2f',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
      >
        ← ආපසු
      </button>

      <h1 style={{ color: '#0b6b2f', fontSize: 28, marginBottom: 12, textAlign: 'justify' }}>අපගේ සේවාවන්</h1>
      <hr className="footer-sep" />
      <ul style={{ marginLeft: 24, fontSize: 19, marginBottom: 24, textAlign: 'justify', listStyleType: 'disc' }}>
        <li>නව කෘෂිකාර්මික දැනුම ගොවීන්ට ලබාදීම</li>
        <li>කෘෂිකාර්මික වැඩසටහන් සදහා විවිධ සහනාධාර ක්‍රම ක්‍රියාත්මක කිරීම</li>
        <li>උසස් තත්වයේ බීජ හා රෝපණ ද්‍රව්‍ය නිෂ්පාදනය හා බෙදා හැරීම</li>
        <li>පසු අස්වනු තාක්ෂණ ක්‍රම හදුන්වාදීම</li>
        <li>පර්යේෂණ හා අත්හදා බැලීම් ගොවි ක්ෂේත්‍ර තුල ක්‍රියාත්මක කිරීම</li>
        <li>නව වර්ග හා ප්‍රභේද පළාත තුල ක්‍රියාත්මක කිරීම</li>
        <li>කෘෂිකාර්මික සංඛ්‍යාලේඛණ හා දත්ත රැස්කිරීම</li>
        <li>ගොවීන් නිලධාරීන් හා පාසල් සිසුන් සදහා පුහුණු කිරීම</li>
        <li>කාබනික වගා ප්‍රවර්ධනය</li>
        <li>තරුණ තරුණියන් කෘෂිකාර්මික කටයුතු කෙරෙහි නැඹුරු කිරීම</li>
        <li>බිම්මල් වගාව හා මීමැසි පාලනය ප්‍රවර්ධනය කිරීම</li>
        <li>අලෙවි කටයුතු සදහා සපයන සේවාවන් ක්‍රියාත්මක කිරීම</li>
        <li>ගෙවතු වගා තාක්ෂණය ලබාදීම</li>
        <li>දේශීය අල බෝග ව්‍යාප්ත කිරීම</li>
        <li>කාන්තා කෘෂි ව්‍යාප්ති කටයුතු සිදුකිරීම</li>
        <li>පලිබෝධනාශක පනත ක්‍රියාත්මක කිරීම</li>
        <li>පැලෑටි සංරක්ෂණ පනත ක්‍රියාත්මක කිරීම</li>
        <li>පස් සංරක්ෂණ පනත ක්‍රියාත්මක කිරීම</li>
        <li>පස් පරීක්ෂාකර පොහොර නිර්දේශ ලබාදීම</li>
        <li>පාසල් කෘෂිකාර්මික වැඩසටහන් ක්‍රියාත්මක කිරීම</li>
        <li>විදේශීය අනුග්‍රහය ලබන කෘෂිකාර්මික ව්‍යාපෘති ක්‍රියාත්මක කිරීම</li>
        <li>කෘෂි ව්‍යාපාර සදහා මග පෙන්වීම</li>
        <li>කෘෂි විශේෂ ව්‍යාපෘති ක්‍රියාත්මක කිරීම</li>
        <li>ගොවිපල් සදහා GAP සහතිකකරණය</li>
      </ul>
    </main>
  );
}